import {getUserName} from 'src/modules/downloads/utils/get-user-name';
import {User} from 'src/openapi/models/User';

export const userEmailsToUserNames = (
    userEmails: string[],
    usersInfo: Record<string, User>,
): string[] => {
    return userEmails.map(email => getUserName(email, usersInfo[email]));
};
